export const FLOW_MANAGEMENT = {
  DEPROVISION_FLOW: 'DEPROVISION_FLOW',
  FETCH_ACC_AVAILABLE_FLOWS: 'FM/FETCH_ACC_AVAILABLE_FLOWS',
  FETCH_ACC_LIST_FILTERS: 'FM/FETCH_ACC_LIST_FILTERS',
  FETCH_FLOW_DETAILS: 'FM/FETCH_FLOW_DETAILS',
  FETCH_PROVISIONED_FLOW_ACC_AND_ORG: 'FM/FETCH_PROVISIONED_FLOW_ACC_AND_ORG',
  FETCH_PROVISIONED_FLOW_ORG: 'FM/FETCH_PROVISIONED_FLOW_ORG',
  FETCH_ORG_AVAILABLE_FLOWS: 'FM/FETCH_ORG_AVAILABLE_FLOWS',
  FETCH_ORG_LIST_FILTERS: 'FM/FETCH_ORG_LIST_FILTERS',
  FETCH_CR_PROVISIONED_FLOW_LIST_FILTERS: 'FETCH_CR_PROVISIONED_FLOW_LIST_FILTERS',
  FETCH_CR_PROVISIONED_FLOWS: 'FETCH_CR_PROVISIONED_FLOWS',
  FETCH_ORG_PROVISIONED_FLOWS: 'FM/FETCH_ORG_PROVISIONED_FLOWS',
  FETCH_PLATFORM_LIST_FILTERS: 'FM/FETCH_PLATFORM_LIST_FILTERS',
  FETCH_FLOW_OVERVIEW: 'FETCH_FLOW_OVERVIEW',
  PROVISION_ORG_FLOWS: 'FM/PROVISION_ORG_FLOWS',
  PROVISION_PLATFORM_FLOWS: 'FM/PROVISION_PLATFORM_FLOWS',
  PROVISION_FLOWS: 'FM/PROVISION_FLOWS',
};
